import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';

const FADE_IN = [0.3, 0.35];
const FADE_OUT = [0.75, 0.8];

// Fade del contingut mapejat al progrés de l'item (bidireccional). Com que ara hi ha el spacer de
// 100vh al davant, tots els items (inclòs el primer) entren des de progress 0 → el fade-in és
// automàtic amb l'scroll (la intro és un scroll programàtic de la Home, un scroll REAL).
class ScrollItem__WidgetHomeText extends Scroll_Item {

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._content = __link.children[0] || null; // el > div (contingut, insider)
        if (this._content) this._content.style.opacity = 0; // opacitat inicial 0

        this.onShow = () => { };
        this.onHide = () => { };
        this.onMove = () => {
            if (!this._content) return;
            this._content.style.opacity = this._opacityAt(this.progressItem);
        };
    }

    // Opacitat que toca segons el progress: fade in [FADE_IN] i fade out [FADE_OUT].
    _opacityAt(p) {
        const fadeIn = Maths.clamp(Maths.normalize(FADE_IN[1], FADE_IN[0], p), 0, 1);
        const fadeOut = Maths.clamp(Maths.normalize(FADE_OUT[1], FADE_OUT[0], p), 0, 1);
        return Maths.clamp(fadeIn - fadeOut, 0, 1);
    }
}

Scroll._registerClass('WidgetHomeText', ScrollItem__WidgetHomeText);

export default ScrollItem__WidgetHomeText;
